/**
 * strap-renderer.js — paints the layer stack. EVERY layer is a plain <img> (exactly like the buckle,
 * which is proven to render on the live theme) — no CSS masks. Each recolour option is a pre-rendered
 * coloured image the renderer swaps in.
 *
 * The LEATHER BASE is an in-flow <img> (position:relative, width:100%, height:auto): it defines the
 * stage's real pixel height. Every other layer is absolute top/left/width/height:100% and overlays
 * the base pixel-perfectly. Flicker-free swaps via a monotonic version token + img.decode() + cache.
 * No setTimeout / observers / DOM hacks.
 */
(function (SB) {
  'use strict';

  /* Co nang luc (2026-08-18): form-preview CHI phat lop cssmask khi renderer nay da
     nap. CDN phat tan tung file doc lap -> co cua so form-moi + renderer-cu; thieu co
     nay renderer cu ve mask trang nhu <img> — chi trang tren da sang = "khong hien". */
  SB.RENDERER_CSSMASK = true;

  SB.createRenderer = function (stageEl) {
    var M = SB.MANIFEST;
    var nodes = {};
    var cache = {};
    var version = 0;
    var pending = 0;

    /* B6-B (20/09, chu shop chot): lop ve qua CDN &width= theo DPR — width = min(1254, ceil(cssPx x DPR / 100) x 100):
       PC DPR1 750 css -> 800; PC DPR2 -> 1254 = file nguyen (khong tham so); dien thoai 330 css DPR3 -> 1000; zoom luon file nguyen.
       Khung con [hidden] luc init (be rong 0) -> 0,91 x be rong cot cha (do 20/09: 360 -> 330 mobile, 825 -> 750 PC). Tinh MOT lan,
       dong bang ca phien: tier nam trong URL = khoa cache, am truoc va ve that phai cung URL. */
    var TIER = (function () {
      try {
        /* 20/09 LAM LAI: Liquid (strap-live-preview.liquid) preload san THAN mac dinh theo media (dien thoai 1000 / PC DPR1 800 / PC DPR2 nguyen);
           JS lay dung tier cua link dang khop de khung dau chi tai MOT URL (khong tai doi). Khong co link -> cong thuc theo khung. */
        var lks = document.querySelectorAll('link[rel="preload"][data-cspv-moi]');
        for (var i = 0; i < lks.length; i++) {
          var md = lks[i].getAttribute('media');
          if (!md || (window.matchMedia && window.matchMedia(md).matches)) {
            var mm = (lks[i].getAttribute('href') || '').match(/[?&]width=(\d+)/);
            return mm ? +mm[1] : 0;
          }
        }
        var w = stageEl.getBoundingClientRect().width;
        if (!w) {
          var wrap = stageEl.closest ? stageEl.closest('[data-cspv-wrap]') : null;
          var cot = (wrap && wrap.parentElement) ? wrap.parentElement.getBoundingClientRect().width : 0;
          if (!cot) { var head = document.querySelector('.cstrap__head'); cot = head ? head.getBoundingClientRect().width : 0; }
          w = (cot || document.documentElement.clientWidth) * 0.91;
        }
        var t = Math.ceil(w * (window.devicePixelRatio || 1) / 100) * 100;
        return t >= 1254 ? 0 : t;   /* 0 = file nguyen */
      } catch (e) { if (window.console) console.warn('TIER loi:', e); return 0; }
    })();
    function layerUrl(f, w) {
      var u = SB.assetUrl(f);
      if (!u) return u;
      var t = (w === undefined) ? TIER : w;
      return t ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + t : u;
    }
    /* B6-C: ban mo (than width=150) dang hien tam trong luc cho khung that */
    var verDaAp = 0, moTam = null, moNac = 0;   /* moNac: 1 = swatch o mau (cache, ~0 ms), 2 = than width=150; nac cao hon moi de len */
    function boMo() {
      if (!moTam) return;
      moTam = null; moNac = 0;
      var b = nodes.base;
      if (b) { b.style.filter = ''; b.style.width = ''; b.style.height = ''; b.style.objectFit = ''; }
      stageEl.removeAttribute('data-mo');
    }
    function apMo(url, ver, blur, nac) {
      if (ver !== version || verDaAp >= ver || !nodes.base || (moTam && moNac > nac)) return;
      var b = nodes.base;
      if (!moTam) {
        var hien = {};
        M.layerOrder.forEach(function (n) { if (nodes[n]) hien[n] = !nodes[n].hidden; });
        /* KHOA CO KHUNG: anh mo chi 150-160 px, de tu nhien thi khung co lai roi bung ra = giat bo cuc. Co khung that (data-src)
           -> giu dung co dang hien; lan dau (chua co) -> be rong CONTENT cua cot cha (bo padding: .cspv__frame 825 -> 750 PC,
           359 -> 330 mobile), vuong 1:1 (moi bo layer deu vuong). Khong lay be rong hop <img> trong (150 x 16). */
        var cot = 0;
        if (b.getAttribute('data-src')) cot = b.getBoundingClientRect().width;
        if (!cot && stageEl.parentElement) {
          var pe = stageEl.parentElement, cs = window.getComputedStyle(pe);
          cot = pe.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        }
        /* .sb-base co max-height (42svh mobile = 330 o 390x844; 100vh - 15rem = 750 o 1440x900) va khung vuong -> canh nao nho hon quyet dinh */
        var mh = parseFloat(window.getComputedStyle(b).maxHeight);
        if (mh > 20 && mh < cot) cot = mh;
        moTam = { hien: hien };
        if (cot > 20) { b.style.width = cot + 'px'; b.style.height = cot + 'px'; b.style.objectFit = 'cover'; }
      }
      moNac = nac;
      M.layerOrder.forEach(function (n) { if (nodes[n] && n !== 'base') nodes[n].hidden = true; });
      b.src = url;   /* khong doi data-src: khung that ve sau van ap */
      b.style.filter = blur;
      b.hidden = false;
      stageEl.setAttribute('data-mo', String(nac));
    }
    function hienMo(url, ver, blur, nac) {
      ensureImage(url).then(function (ti) {
        if (!ti) return;
        requestAnimationFrame(function () { apMo(url, ver, blur, nac); });
      }, function (e) { if (window.console) console.warn('hienMo loi:', e); });
    }
    function traMo() {   /* khung that hong -> tra lai khung cu: src theo data-src, lop nao truoc do hien thi hien lai */
      if (!moTam) return;
      var b = nodes.base, hien = moTam.hien;
      if (b && b.getAttribute('data-src')) b.src = b.getAttribute('data-src');
      M.layerOrder.forEach(function (n) { if (nodes[n] && n !== 'base') nodes[n].hidden = !hien[n]; });
      boMo();
    }

    M.layerOrder.forEach(function (name, i) {
      var el = new Image();
      el.className = (name === 'base') ? 'sb-base' : 'sb-l sb-img';
      el.alt = (name === 'base') ? 'Watch strap preview' : '';
      el.decoding = 'async';
      if (name === 'base') el.setAttribute('fetchpriority', 'high');   /* 19/09: than la thu khach cho; ensureImage da fetchPriority high, ghi ro tren node */
      el.style.zIndex = String(i + 1);
      el.setAttribute('data-layer', name);
      stageEl.appendChild(el);
      nodes[name] = el;
    });

    /* PHASE 02 (2026-08-17): lop 'cssmask' — 1 anh mask dung chung (file -white, shading
       nam trong kenh ALPHA, RGB phang: kiem chung std 2-5/255 tren 6 dong da) +
       background-color theo hex. Doi mau chi = doi mot dong CSS, 0 request — dung co che
       mocgoods. Node stitch bien hinh img<->span tuy frame (dong da chua kiem chung van
       di duong img cu). */
    function morphNode(name, wantSpan) {
      var el = nodes[name];
      if (!el) return null;
      var laSpan = el.tagName === 'SPAN';
      if (laSpan === wantSpan) return el;
      var moi = wantSpan ? document.createElement('span') : new Image();
      moi.className = wantSpan ? 'sb-l sb-cssmask' : 'sb-l sb-img';
      if (!wantSpan) { moi.alt = ''; moi.decoding = 'async'; }
      else {
        moi.style.position = 'absolute';
        moi.style.left = '0'; moi.style.top = '0';
        moi.style.width = '100%'; moi.style.height = '100%';
        moi.style.pointerEvents = 'none';
      }
      moi.style.zIndex = el.style.zIndex;
      moi.setAttribute('data-layer', name);
      moi.hidden = true;
      stageEl.replaceChild(moi, el);
      nodes[name] = moi;
      return moi;
    }

    /* Spinner co 300ms an han (2026-08-05): cu tai 60-150ms khong dang mot cai chop -
       chi khi thuc su phai CHO (mang lanh/cham) vong xoay moi xuat hien. */
    var _ldTimer = null;
    /* 20/09 toi (chu shop): BO vong xoay giua khung — giu anh cu ma xoay len no la mau thuan. Sau ~700 ms chua ve, renderer bao
       preview (su kien 'cspv:dangtai') de danh dau "dang tai" tren CHINH O khach vua bam (nhap vien o); ve xong thi tat. */
    var _dangTai = false;
    function baoDangTai(on) { _dangTai = on; try { stageEl.dispatchEvent(new CustomEvent('cspv:dangtai', { detail: { on: on } })); } catch (e) { if (window.console) console.warn('baoDangTai loi:', e); } }
    function setLoading(on) {
      if (on) {
        if (_ldTimer || _dangTai) return;
        _ldTimer = setTimeout(function () { _ldTimer = null; baoDangTai(true); }, 650);   /* 650 trong renderer = ~700 ms sau click (refresh tre 40 + rAF) */
      } else {
        if (_ldTimer) { clearTimeout(_ldTimer); _ldTimer = null; }
        if (_dangTai) baoDangTai(false);
      }
    }

    var inflight = {}, dangTaiWarm = {};   /* dangTaiWarm[url] = ham huy — anh WARM dang bay (ca hai lan); anh render that khong nam day */
    /* 20/09 LAM LAI (chu shop bac B6 warm ca kho): warm BAM LUONG KHACH — dot 1 than moi mau dong dang xem, dot 2 mask dong dang xem
       (lan UU TIEN); dot 3 than dong khac, dot 4 khoa/lot/con lai (lan NEN — chi chay khi lan uu tien da can). Bon chot chan #5 (16/09):
       (1) chi khi trang RANH: moi dot bat dau qua requestIdleCallback, khong co ric -> khong warm; (2) mang 2g/3g/saveData -> preview khong
       xep gi; (3) khach bam -> huyWarm() cat moi anh warm dang bay (img.src=''), xep lai DAU hang lan do, nghi 1,5 s; (4) fetchPriority low,
       nhuong khi co render that dang cho. Khong warm gi truoc khi KHUNG DAU ve xong (tVeXongDau). */
    var hangUT = [], hangNen = [], hangSet = {}, dangBom = false, bayUT = 0, bayNen = 0, dangRic = false;
    var UT_TOI_DA = 4, UT_TOI_DA_RANH = 12, UT_RANH_MS = 1000, NEN_TOI_DA = 1, NEN_TOI_DA_RANH = 3, NEN_RANH_MS = 3000, NGHI_MS = 1500;
    function utToiDa() { return (Date.now() - nghiToi + NGHI_MS) >= UT_RANH_MS ? UT_TOI_DA_RANH : UT_TOI_DA; }
    function nenToiDa() { return (Date.now() - nghiToi + NGHI_MS) >= NEN_RANH_MS ? NEN_TOI_DA_RANH : NEN_TOI_DA; }
    var soRender = 0, tVeXongDau = 0, nghiToi = 0, _bomT = null;
    /* chot #1 SUA 20/09 (chu shop): lan UU TIEN (than + mask dong khach VUA CHON) chay ngay khi co slot — khach da noi ro y, khong cho ranh,
       khong nghi 1,5 s; chi nhuong khi co render that dang cho. Lan NEN (dong cung nhom, khoa) van cho ranh: ric; trinh duyet KHONG co ric
       (Safari/iOS — moi ban toi nay) -> hoan co dinh sau `load` bang setTimeout (truoc 20/09: "khong ric -> khong warm" lam iPhone chua
       tung warm, moi mau bam lan dau deu lanh 300-400 ms). */
    function utDuocChay() { return !!tVeXongDau && pending === 0; }
    function warmDuocChay() { return !!tVeXongDau && Date.now() >= nghiToi && pending === 0; }
    function khiRanh(cb) {
      if (window.requestIdleCallback) return window.requestIdleCallback(cb, { timeout: 1500 });
      var chay = function () { setTimeout(cb, 300); };
      if (document.readyState === 'complete') chay(); else window.addEventListener('load', chay, { once: true });
    }
    function henBom(ms) { clearTimeout(_bomT); _bomT = setTimeout(bomHang, ms); }
    function batDau(u, nen) {
      delete hangSet[u];
      if (nen) bayNen++; else bayUT++;
      var xong = function () { if (nen) bayNen--; else bayUT--; bomHang(); };
      ensureImage(u, true, nen ? 'nen' : 'ut').then(xong, xong);
    }
    function huyWarm() {
      var ds = Object.keys(dangTaiWarm);
      for (var i = ds.length - 1; i >= 0; i--) { var h = dangTaiWarm[ds[i]]; if (h) h(); }
      return ds.length;
    }
    function bomHang() {
      if (dangBom) return;
      dangBom = true;
      setTimeout(function () {
        dangBom = false;
        if (!hangUT.length && !hangNen.length) return;
        if (!tVeXongDau) return;   /* khung dau chua ve: doRender se goi bomHang() luc ap khung */
        if (pending > 0) { henBom(300); return; }
        /* lan UU TIEN: ngay */
        while (hangUT.length && bayUT < utToiDa()) batDau(hangUT.shift(), false);
        /* lan NEN: chi khi lan uu tien da can, trang ranh (ric / hoan sau load), qua 1,5 s ke tu cu bam cuoi */
        if (!hangNen.length || hangUT.length || bayUT) return;
        if (!warmDuocChay()) { var now = Date.now(), cho = 300; if (now < nghiToi) cho = Math.max(cho, nghiToi - now); henBom(cho); return; }
        if (dangRic) return;
        dangRic = true;
        khiRanh(function () {
          dangRic = false;
          if (!warmDuocChay() || hangUT.length || bayUT) { henBom(300); return; }
          while (hangNen.length && bayNen < nenToiDa()) batDau(hangNen.shift(), true);
        });
      }, 0);
    }
    /* 2026-08-19: URL chet (404) duoc ghi so 90s — truoc day "KHONG cache de lan sau
       tu xin lai" lam moi luot warm/render xin lai du bo URL hong x3 retry (do live:
       8 file otsw + 3 base swatch-only = ~30 request rac moi phien mobile). 90s du
       chan storm trong phien, van tu phuc hoi neu do mang chap chon. */
    var dead = {};
    function ensureImage(url, low, lan) {   /* lan: 'ut' | 'nen' = anh warm (huy duoc, xep lai); undefined = render that */
      if (cache[url]) return Promise.resolve(cache[url]);
      if (dead[url] && Date.now() < dead[url]) return Promise.resolve(null);
      /* onload moi la bang chung co pixel (iOS reject decode() bay); loi thi retry voi
         backoff DAI dan 0.8s->2s: CDN Shopify gian 429 khi bi doi nhieu, thu lai qua som
         chi an them 429 (do duoc 2026-08-05). That bai han -> null, KHONG cache de lan
         render sau tu xin lai. inflight chan viec warm va render cung xin mot URL thanh
         hai request song song. */
      if (inflight[url]) return inflight[url];
      inflight[url] = new Promise(function (resolve) {
        var daHuy = false;
        var attempt = function (left, cho) {
          if (daHuy) return;
          var img = new Image();
          /* Phase 01 (2026-08-17): anh warm xep hang THAP, anh render that hang CAO -
             cu bam cua khach khong bao gio doi sau hang warm. Trinh duyet cu bo qua
             fetchPriority, vo hai. */
          img.fetchPriority = low ? 'low' : 'high';
          img.onload = function () {
            var done = function () { cache[url] = img; delete inflight[url]; delete dangTaiWarm[url]; resolve(img); };
            if (img.decode) img.decode().then(done, done); else done();
          };
          img.onerror = function () {
            if (left > 0) setTimeout(function () { attempt(left - 1, cho * 2.5); }, cho);
            else { dead[url] = Date.now() + 90000; delete inflight[url]; delete dangTaiWarm[url]; resolve(null); }
          };
          if (lan) dangTaiWarm[url] = function () {   /* huyWarm(): cat request, tra slot, xep lai DAU hang cua lan do (chot #3) */
            daHuy = true; img.onload = null; img.onerror = null; img.src = '';
            delete inflight[url]; delete dangTaiWarm[url];
            if (!cache[url] && !hangSet[url]) { hangSet[url] = true; (lan === 'nen' ? hangNen : hangUT).unshift(url); }
            resolve(null);
          };
          img.src = url;
        };
        attempt(2, 800);
      });
      return inflight[url];
    }

    /* RENDER NGUYEN KHUNG (chu shop 2026-08-05, "fix triet de"): ban cu thay TUNG lop ngay
       khi anh cua lop do ve - mask nho ve truoc dap len khung cua base cu/chua co, cac lop
       lech nhau roi mo dan vao cho (lo ro nhat o Ostrich vi doi da la doi ca he canvas).
       Gio: gom DU anh cua toan bo lua chon roi moi thay TAT CA trong mot nhip rAF.

       - Frame moi hon dang bay -> frame cu huy TRON, khong ap nua voi (khac loi lich su
         "counter bo roi frame": hoi do tung node tu ap tu cache con node cham bi bo -
         atomic ap tat-hoac-khong nen khong bao gio co node trang).
       - Base moi khong ve duoc ma dang co bo cu nhat quan -> GIU NGUYEN bo cu.
       - Mask hong -> an node do (thieu con hon sai khung/sai mau), tu hen thu lai toi da
         3 nhip vi sig ben adapter khong doi thi khong ai goi render lai nua. */
    /* #2 (2026-09-16): tra ve Promise de adapter biet luc nao khung da ve XONG, roi moi
       tha warm cua dong da. Truoc day warm chi nhuong theo `pending`, ma anh nen lai duoc
       xin SAU khi 10 o swatch + dot warm cu da bay -> tren 3G anh nen ve o ~2,9 s. */
    function doRender(layers, ver, attempt) {
      var jobs = layers.map(function (d) {
        return { name: d.layer, url: layerUrl(d.src), src: d.src, mo: d.mo, kind: d.kind, color: d.color };
      });
      var present = {};
      jobs.forEach(function (j) { present[j.name] = true; });
      var allWarm = jobs.every(function (j) { return !!cache[j.url]; });
      if (!allWarm) { pending++; setLoading(true); }
      /* B6-C (20/09, chu shop): THAN LANH -> hien ngay ban nho width=150 (2-4 KB) cua DUNG dong vua chon, lam mo nhe, cac lop khac an
         toi khi ca khung ve xong — khong de dong cu tro, khong man trong. Chi ap khi luot nay van moi nhat va khung that chua ve. */
      var baseLanh = null;
      jobs.forEach(function (j) { if (j.name === 'base' && !cache[j.url]) baseLanh = j; });
      /* mo bang thoi gian THAN ve (chu shop 20/09: "tu luc bam toi luc than day dung mau hien ra") — harness doc window.__R */
      /* 20/09 LAM LAI: ban mo CHI cho lan ve dau khi khung con trong (chua co data-src); moi luot sau GIU anh cu toi khi bo moi xong. */
      if (baseLanh && nodes.base && !nodes.base.getAttribute('data-src')) {
        if (baseLanh.mo) apMo(baseLanh.mo, ver, 'blur(10px)', 1);
        hienMo(layerUrl(baseLanh.src, 150), ver, 'blur(4px)', 2);
      }
      /* THAN DAY xin TRUOC, hang cao; chi/vien/lo/khoa/lot xin sau, hang thap — khach thay dung mau day som nhat, bo moi thay ca khung mot nhip. */
      var pBase = baseLanh ? ensureImage(baseLanh.url) : null;
      return Promise.all(jobs.map(function (j) {
        var pr = (j === baseLanh) ? pBase : ensureImage(j.url, j.name !== 'base');
        return pr.then(function (ok) { j.ok = !!(ok && ok.naturalWidth); });
      })).then(function () {
        requestAnimationFrame(function () {
          if (!allWarm) pending = Math.max(0, pending - 1);
          if (ver !== version) { if (!pending) setLoading(false); return; }
          verDaAp = ver;
          var baseJob = null, hong = false;
          jobs.forEach(function (j) { if (j.name === 'base') baseJob = j; if (!j.ok) hong = true; });
          if (baseJob && !baseJob.ok && nodes.base && nodes.base.getAttribute('data-src')) {
            /* giu nguyen frame cu - dong bo tu than con hon nua cu nua moi */
            traMo();
          } else {
            jobs.forEach(function (j) {
              if (!nodes[j.name]) return; /* lop la khong co node: bo qua, khong keo chet ca frame */
              var el = morphNode(j.name, j.kind === 'cssmask');
              if (j.ok) {
                if (j.kind === 'cssmask') {
                  /* data-src mang ca mau: doi MAU khong doi mask van phai ap lai style */
                  var khoa = j.url + '|' + (j.color || '');
                  if (el.getAttribute('data-src') !== khoa) {
                    el.style.webkitMaskImage = 'url("' + j.url + '")';
                    el.style.maskImage = 'url("' + j.url + '")';
                    el.style.webkitMaskSize = '100% 100%';
                    el.style.maskSize = '100% 100%';
                    el.style.webkitMaskRepeat = 'no-repeat';
                    el.style.maskRepeat = 'no-repeat';
                    el.style.backgroundColor = j.color || '#000';
                    el.setAttribute('data-src', khoa);
                  }
                  el.hidden = false;
                } else {
                  if (el.getAttribute('data-src') !== j.url) { el.src = j.url; el.setAttribute('data-src', j.url); }
                  el.hidden = false;
                }
              } else {
                el.hidden = true;
              }
            });
            M.layerOrder.forEach(function (n) { if (!present[n] && nodes[n]) nodes[n].hidden = true; });
            boMo();
          }
          if (!pending) setLoading(false);
          if (!tVeXongDau) { tVeXongDau = Date.now(); bomHang(); }   /* khung dau da ve -> tu day moi duoc warm (chu shop 20/09) */
          if (hong && attempt < 3) setTimeout(function () { if (ver === version) doRender(layers, ver, attempt + 1); }, 1500);
        });
      });
    }

    var api = {
      /* B6 (20/09) */
      tier: TIER,                                             /* 0 = file nguyen */
      layerUrl: layerUrl,
      amTho: function (urls) { (urls || []).forEach(function (u) { if (u) ensureImage(u, true); }); },   /* zoom: file nguyen theo URL tuyet doi */
      _trangThai: function () {   /* debug: harness doc trang thai hai lan */ return { dangTaiWarm: Object.keys(dangTaiWarm).length, bayUT: bayUT, bayNen: bayNen, hangUT: hangUT.length, hangNen: hangNen.length, utChay: utDuocChay(), warmChay: warmDuocChay(), nenToiDa: nenToiDa(), pending: pending, dangBom: dangBom, soRender: soRender, cache: Object.keys(cache).length, inflight: Object.keys(inflight).length }; },
      render: function (layers) {
        /* khach vua doi lua chon: HUY moi anh warm dang bay (chot #3), xep lai dau hang, ca hai lan nghi 1,5 s */
        soRender++; nghiToi = Date.now() + NGHI_MS;
        huyWarm();
        return doRender(layers, ++version, 0);
      },
      huyWarm: huyWarm,
      /* 19/09 (chu shop chot, buoc A): MOT hang doi am toan cuc, KHONG HUY — chi doi thu tu uu tien. Cach MocGoods:
         am ca catalog nho giot, dung khi roi trang. prefetch(files, uuTien): uuTien = true -> chen DAU hang (mau ke,
         dong da dang chon); mac dinh noi cuoi (cac dong khac). Bo qua file da cache/inflight/da nam trong hang.
         Hai lan (xem tren): uu tien <= 4 bay, nen <= 1 bay + nghi 1,5 s sau moi doi lua chon + hoan 9 s / cu bam dau.
         (Truoc: moi lan goi mo mot vong nho giot rieng + huy bang conSong -> hang cu bi bo, khach quay lai dang cu la lanh.) */
      /* prefetch(files, lan): true = di NGAY (mau ke / re-cham, 1-3 file); 'dau' = dau lan uu tien (dong dang chon, cap 4);
         'nen' = lan nen (catalog dong khac); mac dinh = cuoi lan uu tien (mask dong dang chon). */
      prefetch: function (filenames, lan) {
        var moi = [];
        (filenames || []).forEach(function (f) {
          var u = layerUrl(f);
          if (!u || cache[u] || inflight[u]) return;
          if (hangSet[u]) {
            /* B6-C (20/09): da nam trong hang. Khach bam som ('dau' / true) -> keo tu LAN NEN len lan uu tien; con lai giu cho cu. */
            if (lan !== 'dau' && lan !== true) return;
            var i = hangNen.indexOf(u);
            if (i < 0) return;
            hangNen.splice(i, 1);
          } else hangSet[u] = true;
          moi.push(u);
        });
        if (!moi.length) return;
        if (lan === 'nen') hangNen = hangNen.concat(moi);
        else if (lan === 'dau') hangUT = moi.concat(hangUT);   /* dong dang chon: DAU lan uu tien, van cap 4 (khong bay 23 anh cung luc) */
        else if (lan === true) {
          /* mau ke / re-cham (1-3 file, khach sap bam): KHOI DONG NGAY, khong cho slot — do 19/09: xep dau hang ma 4 slot dang
             ban mask + than dong thi mau ke van cho, cu bam ke tiep thanh lanh (66 -> 217 ms). Van dem vao bayUT de am hang loat cho. */
          if (!utDuocChay()) hangUT = moi.concat(hangUT);
          else moi.forEach(function (u) { batDau(u, false); });
        }
        else hangUT = hangUT.concat(moi);
        bomHang();
      }
    };
    SB._renderer = api;   /* harness / debug */
    return api;
  };
})(window.StrapBuilder = window.StrapBuilder || {});

/* build 2026-08-19T1 - negative-cache URL chet 90s
   build 2026-08-17T2 - phase 02: lop cssmask cho mau chi, pha cache edge */
